import ConfirmModal from '../confirm_modal/confirm_modal.vue'
import UserAvatar from '../user_avatar/user_avatar.vue'

const DMConvCard = {
  components: {
    ConfirmModal,
    UserAvatar
  },

  props: {
    conversation: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: true
    },
    showLastStatus: {
      type: Boolean,
      default: true
    },
    showFullControls: {
      type: Boolean,
      default: false
    },
    linkToTimeline: {
      type: Boolean,
      default: true
    }
  },

  emits: ['deleted'],

  data () {
    return {
      showingDeleteConfirmDialogue: false
    }
  },

  computed: {
    shouldConfirmDelete () {
      return this.$store.getters.mergedConfig.modalOnDeleteDMConversation
    },

    currentUserId () {
      return String(this.$store.state.users.currentUser?.id || '')
    },

    otherMembers () {
      const accounts = this.conversation.accounts || []
      const others = accounts.filter(user => String(user.id) !== this.currentUserId)
      return others.length ? others : accounts
    },

    primaryMember () {
      return this.otherMembers[0] || null
    },

    conversationName () {
      if (!this.primaryMember) return `Conversation ${this.conversation.id}`

      if (this.otherMembers.length > 1) {
        const names = this.otherMembers
          .slice(0, 3)
          .map(user => user.name || user.screen_name || user.nickname)
          .filter(Boolean)

        return names.join(', ') + (this.otherMembers.length > 3 ? '…' : '')
      }

      return this.primaryMember.name ||
        this.primaryMember.screen_name ||
        this.primaryMember.nickname ||
        'Direct message'
    },

    conversationHandle () {
      if (!this.primaryMember || this.otherMembers.length > 1) return ''

      const handle =
        this.primaryMember.screen_name ||
        this.primaryMember.nickname ||
        this.primaryMember.acct ||
        ''

      if (!handle) return ''
      return handle.startsWith('@') ? handle : `@${handle}`
    },

    lastMessage () {
      const status = this.conversation.last_status
      if (!status) return 'No messages yet'

      const raw = status.content || status.text || ''

      const div = document.createElement('div')
      div.innerHTML = raw

      return (div.textContent || div.innerText || '')
        .replace(/\s+/g, ' ')
        .trim() || 'Attachment'
    },

    lastMessageTime () {
      const value = this.conversation.last_status?.created_at
      if (!value) return ''

      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''

      const now = new Date()
      const sameDay = date.toDateString() === now.toDateString()

      if (sameDay) {
        return date.toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit'
        })
      }

      return date.toLocaleDateString([], {
        month: 'short',
        day: 'numeric'
      })
    }
  },

  methods: {
    markRead () {
      this.$store.dispatch('markDMConversationAsRead', {
        id: this.conversation.id
      })
    },

    openConversation () {
      if (!this.linkToTimeline) return

      if (this.conversation.unread) {
        this.markRead()
      }

      this.$router.push({
        name: 'dm_conversation',
        params: { id: this.conversation.id }
      })
    },

    showDeleteConfirmModal () {
      this.showingDeleteConfirmDialogue = true
    },

    hideDeleteConfirmModal () {
      this.showingDeleteConfirmDialogue = false
    },

    deleteConversation () {
      if (this.shouldConfirmDelete) {
        this.showDeleteConfirmModal()
      } else {
        this.doDeleteConversation()
      }
    },

    doDeleteConversation () {
      this.$store.dispatch('deleteDMConversation', {
        id: this.conversation.id
      })

      this.hideDeleteConfirmModal()
      this.$emit('deleted')
    }
  }
}

export default DMConvCard
